module.exports = __webpack_public_path__ + "images/join-request-created-ce6f74d623bf7cd6b154a1786258fe16.png";